export interface CommonState {
  summaryTableData: Map<string, any>
}

export const initialCommonState: CommonState = {
  summaryTableData: new Map<string, any>()
}
